import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HelpCircle, Shield, MessageSquare, Mail } from 'lucide-react';
import ContactFormModal from './ContactFormModal';

const Footer = ({ darkMode = false }) => {
  const navigate = useNavigate();
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [contactType, setContactType] = useState('support');

  const footerLinks = [
    {
      name: 'Support',
      icon: HelpCircle,
      onClick: () => {
        setContactType('support');
        setContactModalOpen(true);
      },
      description: 'Get help and support'
    },
    {
      name: 'Privacy',
      path: '/privacy',
      icon: Shield,
      description: 'Privacy policy'
    },
    {
      name: 'Feedback',
      onClick: () => {
        setContactType('feedback');
        setContactModalOpen(true);
      },
      icon: MessageSquare,
      description: 'Send feedback'
    },
    {
      name: 'Contact',
      icon: Mail,
      onClick: () => {
        setContactType('support');
        setContactModalOpen(true);
      },
      description: 'Contact us'
    }
  ];

  const handleLinkClick = (link) => {
    if (link.onClick) {
      link.onClick();
    } else if (link.href) {
      window.location.href = link.href;
    } else if (link.path) {
      navigate(link.path);
    }
  };

  return (
    <footer className={`mt-12 py-8 border-t ${darkMode ? 'border-gray-800 bg-gray-900' : 'border-gray-200 bg-white'}`}>
      <div className="max-w-7xl mx-auto px-4">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand Section */}
          <div className="col-span-1">
            <h3 className={`text-2xl font-bold mb-2 bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent`}>
              emoQ.ai
            </h3>
            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              AI-Powered Emotional Intelligence Analysis
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-span-3">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {footerLinks.map((link) => {
                const Icon = link.icon;
                return (
                  <button
                    key={link.name}
                    onClick={() => handleLinkClick(link)}
                    className={`flex flex-col items-start p-3 rounded-lg transition-all ${
                      darkMode 
                        ? 'hover:bg-gray-800 text-gray-300 hover:text-white' 
                        : 'hover:bg-gray-100 text-gray-700 hover:text-gray-900'
                    }`}
                  >
                    <div className="flex items-center gap-2 mb-1">
                      <Icon className="w-4 h-4" />
                      <span className="font-medium text-sm">{link.name}</span>
                    </div>
                    <span className={`text-xs ${darkMode ? 'text-gray-500' : 'text-gray-500'}`}>
                      {link.description}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className={`pt-6 border-t ${darkMode ? 'border-gray-800' : 'border-gray-200'} flex flex-col md:flex-row justify-between items-center gap-4`}>
          <p className={`text-sm ${darkMode ? 'text-gray-500' : 'text-gray-600'}`}>
            © {new Date().getFullYear()} emoQ.ai. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <button
              onClick={() => navigate('/pricing')}
              className={`text-sm ${darkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`}
            >
              Pricing
            </button>
            <button
              onClick={() => navigate('/api-docs')}
              className={`text-sm ${darkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`}
            >
              API Docs
            </button>
            <a
              href="https://twitter.com/emoqai"
              target="_blank"
              rel="noopener noreferrer"
              className={`text-sm ${darkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`}
            >
              Twitter
            </a>
          </div>
        </div>
      </div>

      {/* Contact Form Modal */}
      <ContactFormModal 
        isOpen={contactModalOpen}
        onClose={() => setContactModalOpen(false)}
        type={contactType}
      />
    </footer>
  );
};

export default Footer;
